var map = {
	"./Ellipse1.png": 310,
	"./Ellipse2.png": 47,
	"./Group.png": 91,
	"./Logo.png": 93,
	"./Vector.png": 35,
	"./auto_detect_voice.png": 450,
	"./background-about.png": 974,
	"./background-mobile-v2.png": 647,
	"./background.png": 306,
	"./cardapio.png": 826,
	"./child_care.png": 157,
	"./diversity_3.png": 637,
	"./quadro.png": 750,
	"./school.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;